import { InjectionToken, makeStateKey } from '@angular/core';

export const SSR_CHANNEL_TOKEN_KEY = makeStateKey<string>('SSR_CHANNEL_TOKEN');
export const CHANNEL_TOKEN_LS_KEY = 'vendure-channel';
export const CHANNEL_TOKEN = new InjectionToken<string | null>('CHANNEL_TOKEN');
export const CHANNEL_TOKEN_COOKIE_KEY = 'channelToken';
